module.exports = __webpack_public_path__ + "static/img/icon-level-03.76b5c5b6.svg";